import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import './index.css';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        backgroundColor: '#f5f7fa',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 2,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          padding: 5,
          borderRadius: '16px',
          textAlign: 'center',
          maxWidth: '450px',
          width: '100%',
        }}
      >
        <WarehouseIcon sx={{ fontSize: 60, color: '#1976d2', mb: 2 }} />
        <Typography variant="h2" component="h1" gutterBottom color="error">
          404
        </Typography>
        <Typography variant="h6" gutterBottom>
          Oops! The page you're looking for doesn't exist.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          It might have been moved or deleted from the warehouse system.
        </Typography>
        <Button
          variant="contained"
          onClick={() => navigate('/')}
          sx={{
            marginTop: 4,
            paddingX: 4,
            paddingY: 1,
            borderRadius: '8px',
            fontWeight: 'bold',
          }}
        >
          Back to Home
        </Button>
      </Paper>
    </Box>
  );
};

export default NotFound;
